@for (version of reversedVersions(); track version.id) {
  <button
    type="button"
    class="version-item"
    [attr.data-selected]="isSelected(version)"
    (click)="selectVersion(version)"
  >
    <div class="version-item-indicator"></div>
    <div class="version-item-content">
      <span class="version-item-content-title">{{ getTitle(version) }}</span>
      <div class="version-item-content-lines">
        <span class="version-item-content-date">{{ version.versionDisplayDate | date: 'MMM d, y' }}</span>
        @if (getActorLabel(version); as actorLabel) {
          <span class="version-item-content-actor">{{ actorLabel }}</span>
        }
      </div>
    </div>
  </button>
}
